import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DumpsterFire} from "../../DumpsterFire";
import {gsap, TimelineLite, TimelineMax} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayUtils} from "../../utils/ArrayUtils";
import {DFGameConfig} from "../../DFGameConfig";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../../core/reel/simplereel/IReelData";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DumpsterFireSymbol} from "../../reels/DumpsterFireSymbol";


export class DumpsterFireNormalResultPresentation implements FlowStatePresentation {
    private _tl: TimelineMax;
    private _stoppedReels: boolean[];
    public readonly DROP_IN_REEL_DELAY: number = 0.03;
    private readonly FAST_DROP_IN_REEL_DELAY: number = 0;

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip())
        this._stoppedReels = [false, false, false, false, false, false];
        this._tl = new TimelineMax();
        let stopTime: number = 0;
        let delay: number = 0;
        let nearWinReel: boolean = false;
        for (let i: number = 0; i < DumpsterFire.model.gameData.reels.length; i++) {
            const reelData: string[] = DumpsterFire.model.gameData.reels[i],
                reelStopAnimation: TimelineMax = new TimelineMax(),
                currentReel: number = JSON.parse(JSON.stringify(i));
            const fastSpin: boolean = DumpsterFire.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
            let stopDelay: number = fastSpin ? this.FAST_DROP_IN_REEL_DELAY : this.DROP_IN_REEL_DELAY;
            nearWinReel = currentReel + 1 < DFGameConfig.totalReels && DumpsterFire.model.nearWinReels[currentReel + 1];
            if (currentReel + 1 < DFGameConfig.totalReels && DumpsterFire.model.nearWinReels[currentReel + 1]) {
                stopDelay += DumpsterFire.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? 0 : 0.7;
            }
            reelStopAnimation.add(this.preventSkipOnLastReel(i, flowStateController));
            reelStopAnimation.add(DumpsterFire.allReelsView.mainReelModels[i].stop(reelData, i, nearWinReel, DumpsterFire.model.nearWinReels[i], fastSpin), delay);
            DumpsterFire.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data: SimpleReelModelEventData) => this.onReelStop(data, flowStateController));
            this._tl.add(reelStopAnimation, stopTime);
            delay += stopDelay;
        }

        const padding: number = DumpsterFire.gameFlowController.calculatePaddingDuration(this._tl.totalDuration());
        if (padding > 0) {
            this._tl.shiftChildren(((DumpsterFire.apiPlugin.gameClientConfiguration.minimumSpinTime / 1000) - this._tl.totalDuration()) * 0.95);
        }
    }

    private preventSkipOnLastReel(reelId: number, flowStateController: FlowStateController) {
        const tl: TimelineMax = new TimelineMax();
        if (reelId == 4) {
            tl.add(() => {
                flowStateController.setSkipCallback();
            }); //prevents useless skips when last reel has started its stop anyway.
        }
        return tl;
    }

    private skip(): void {
        this._tl.timeScale(5);
    }

    private onReelStop(data: SimpleReelModelEventData, flowStateController: FlowStateController) {
        this._stoppedReels[data.reel] = true;
        if (ArrayUtils.isAllTrue(this._stoppedReels)) {
            this.completePresentation(flowStateController)
        }
    }

    private completePresentation(flowStateController: FlowStateController) {
        this._tl.to(this, {duration: 0.4});
        flowStateController.finish();
    }
}